import React from "react";
import PastorUsers from "../pastors/pastor-users/PastorUsers";
import IdleWrapper from "../components/auth/IdleWrapper";

export default function PastorUserPage() {
  return <IdleWrapper><PastorUsers /> </IdleWrapper> ;
}
